var ComposeTarget;
(function (ComposeTarget) {
    ComposeTarget[ComposeTarget["PrimaryReadingPane"] = 0] = "PrimaryReadingPane"; /* default */
    ComposeTarget[ComposeTarget["SecondaryTab"] = 1] = "SecondaryTab"; /* Tab */
    ComposeTarget[ComposeTarget["Popout"] = 2] = "Popout"; /* Popout */
    ComposeTarget[ComposeTarget["SxS"] = 3] = "SxS"; /* SxS */
})(ComposeTarget || (ComposeTarget = {}));
export default ComposeTarget;
//# sourceMappingURL=ComposeTarget.js.map